







import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";
import Owner from "@/model/cospirit-api/Owner";
import EnvIndicator from "@/components/EnvIndicator.vue";

@Component({
    components: {EnvIndicator}
})
export default class App extends Vue {
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    @Action("loadSocleClient") protected loadSocleClient!: () => void;
    @Action("loadTopics") protected loadTopics!: () => void;
    @Action("loadBudgets") protected loadBudgets!: () => void;
    @Action("loadAllocationTypes") protected loadAllocationTypes!: () => void;
    @Action("loadBudgetAllocations") protected loadBudgetAllocations!: () => void;
    @Action("loadTitles") protected loadTitles!: () => void;
    @Action("loadTypes") protected loadTypes!: () => void;
    @Action("loadOwnerReports") protected loadOwnerReports!: () => void;
    @Action("loadRequesters") protected loadRequesters!: (OwnerUuid: string) => void;
    @Action("loadAssignedUsers") protected loadAssignedUsers!: (OwnerUuid: string) => void;
    @Action("loadFeatures") protected loadFeatures!: () => void;
    @Action("loadMasterOwners") protected loadMasterOwners!: () => Promise<void>;
    @Watch("currentOwnerUuid") protected currentOwnerUuidChanged(): void {
        if (this.currentOwnerUuid) {
            this.loadSocleClient();
            this.loadBudgetAllocations();
            this.loadTopics();
            this.loadFeatures();
            this.loadBudgets();
            this.loadAllocationTypes();
            this.loadTitles();
            this.loadTypes();
            this.loadOwnerReports();
            this.loadRequesters(this.currentOwnerUuid);
            this.loadAssignedUsers(this.currentOwnerUuid);
            this.loadMasterOwners();
        }
    }
}
